/** 随机字节数（UUID v4） */
const RANDOM_BYTE_COUNT = 16;
/** 十六进制每位宽度 */
const HEX_PAD_LENGTH = 2;
/** `Number#toString` 进制 */
const HEX_RADIX = 16;
/** 版本字段：高 4 位为 `4`（0x40），低 4 位取随机 */
const UUID_VERSION_BYTE_BASE = 64;
const UUID_VERSION_LOW_NIBBLE_MOD = 16;
/** 变体字段：`10xxxxxx`，即 128 + 低 6 位随机 */
const UUID_VARIANT_BYTE_BASE = 128;
const UUID_VARIANT_LOW_SIX_BITS_MOD = 64;
/** 十六进制串分段下标（8-4-4-4-12） */
const HEX_SLICE_A = 8;
const HEX_SLICE_B = 12;
const HEX_SLICE_C = 16;
const HEX_SLICE_D = 20;
const HEX_SLICE_END = 32;

/** UUID v4，兼容不支持 crypto.randomUUID 的环境（如部分 iOS WebView） */
export function generateUUID(): string {
    const buffer = new Uint8Array(RANDOM_BYTE_COUNT);
    crypto.getRandomValues(buffer);

    buffer[6] = UUID_VERSION_BYTE_BASE + (buffer[6] % UUID_VERSION_LOW_NIBBLE_MOD);
    buffer[8] = UUID_VARIANT_BYTE_BASE + (buffer[8] % UUID_VARIANT_LOW_SIX_BITS_MOD);

    const hex = Array.from(buffer)
        .map(b => b.toString(HEX_RADIX).padStart(HEX_PAD_LENGTH, '0'))
        .join('');

    return `${hex.slice(0, HEX_SLICE_A)}-${hex.slice(HEX_SLICE_A, HEX_SLICE_B)}-${hex.slice(
        HEX_SLICE_B,
        HEX_SLICE_C
    )}-${hex.slice(HEX_SLICE_C, HEX_SLICE_D)}-${hex.slice(HEX_SLICE_D, HEX_SLICE_END)}`;
}
